import type { RoleSource } from '../../types/framework'

export const cro: RoleSource = {
  id: 'cro',
  name: 'Chief Risk Officer',
  group: 'Executive',
  domains: [
    {
      name: 'Board, Executive & Stakeholder Risk Advisory',
      characteristic: [
        [745, "Credibility", "Demonstrates credibility."],
        [746, "Independence and Objectivity", "Demonstrates independent judgment."],
        [747, "Complexity Communication", "Demonstrates ability to explain complexity."],
        [748, "Diplomacy", "Demonstrates diplomacy."],
        [749, "Confidence Under Challenge", "Demonstrates confidence under challenge."],
        [750, "Candid Advisory Judgement", "Demonstrates commitment to candid advice."],
      ],
      behaviour: [
        [751, "Risk Assessment and Oversight", "Provides the board and executives with clear views of material risks and trade-offs."],
        [752, "Constructive Challenge of proposals constructively while supporting informed", "Challenges proposals constructively while supporting informed business decisions."],
        [753, "Communication Skills", "Communicates uncertainty, assumptions and limitations without overstating precision."],
        [754, "Regulatory Compliance and Governance", "Coordinates risk matters across assurance, compliance, finance and operating functions."],
        [755, "Ensuring material risk acceptance decisions are made at", "Ensures material risk acceptance decisions are made at the proper authority level."],
        [756, "Maintenance of relationship with regulators and external assurance", "Maintains an effective relationship with regulators and external assurance parties where applicable."],
      ],
    },
    {
      name: 'Credit, Market, Liquidity & Financial Risk Oversight',
      characteristic: [
        [757, "Understanding of financial risk transmission", "Demonstrates understanding of financial risk transmission."],
        [758, "Prudence", "Demonstrates prudence."],
        [759, "Decision-Making and Judgement", "Demonstrates quantitative judgment."],
        [760, "Awareness of concentration risk", "Demonstrates awareness of concentration risk."],
        [761, "Sensitivity to market conditions", "Demonstrates sensitivity to market conditions."],
        [762, "Independence from commercial pressure", "Demonstrates independence from commercial pressure."],
      ],
      behaviour: [
        [763, "Financial Planning and Forecasting", "Oversees relevant credit, market, liquidity and counterparty risk frameworks."],
        [764, "Monitoring of exposures against approved limits and escalation", "Monitors exposures against approved limits and escalation thresholds."],
        [765, "Assesses concentration, collateral, counterparty and funding vulnerabilities", "Assesses concentration, collateral, counterparty and funding vulnerabilities."],
        [766, "Review of stress scenarios and risk-adjusted performance measures", "Reviews stress scenarios and risk-adjusted performance measures."],
        [767, "Escalates material breaches and deteriorating exposure trends promptly", "Escalates material breaches and deteriorating exposure trends promptly."],
        [768, "Coordination of with finance and treasury while maintaining", "Coordinates with finance and treasury while maintaining independent risk challenge."],
      ],
    },
    {
      name: 'Cyber, Data & Emerging Technology Risk',
      characteristic: [
        [769, "Crisis Leadership and Resilience", "Demonstrates curiosity about emerging threats."],
        [770, "Technology-risk awareness", "Demonstrates technology-risk awareness."],
        [771, "Privacy consciousness", "Demonstrates privacy consciousness."],
        [772, "Change Management", "Demonstrates skepticism about rapid adoption."],
        [773, "Systems thinking", "Demonstrates systems thinking."],
        [774, "Innovation and Transformation", "Demonstrates balanced innovation judgment."],
      ],
      behaviour: [
        [775, "Collaborative Working on with technology leaders to assess", "Works with technology leaders to assess cyber and information risks independently."],
        [776, "Risk Assessment and Oversight", "Oversees risk assessment for material AI, cloud and data initiatives."],
        [777, "Risk Assessment and Oversight", "Ensures cyber scenarios and incident lessons inform the enterprise risk profile."],
        [778, "Monitoring of exposure to data loss, access misuse", "Monitors exposure to data loss, access misuse and technology concentration."],
        [779, "Assesses whether controls match the sensitivity and criticality", "Assesses whether controls match the sensitivity and criticality of information assets."],
        [780, "Reports material technology risks in terms of business", "Reports material technology risks in terms of business impact and response priorities."],
      ],
    },
    {
      name: 'Enterprise Risk Strategy & Risk Appetite',
      characteristic: [
        [781, "Enterprise-wide perspective", "Demonstrates enterprise-wide perspective."],
        [782, "Decision-Making and Judgement", "Demonstrates risk-return judgment."],
        [783, "Independence of thought", "Demonstrates independence of thought."],
        [784, "Strategic risk awareness", "Demonstrates strategic risk awareness."],
        [785, "Proportionality", "Demonstrates proportionality."],
        [786, "Courage to challenge", "Demonstrates courage to challenge."],
      ],
      behaviour: [
        [787, "Strategic Thinking and Alignment", "Aligns the enterprise risk framework with strategy and objectives."],
        [788, "Risk Assessment and Oversight", "Facilitates clear risk appetite and tolerance statements with leadership and the board."],
        [789, "Risk Assessment and Oversight", "Translates risk appetite into practical limits, indicators and escalation triggers."],
        [790, "Risk Assessment and Oversight", "Assesses whether strategic plans remain within approved risk appetite."],
        [791, "Constructive Challenge and Scepticism", "Challenges decisions where risk-return assumptions are weak or inconsistent."],
        [792, "Strategic Thinking and Alignment", "Reviews risk appetite as strategy, markets and exposures change."],
      ],
    },
    {
      name: 'Operational Risk & Resilience',
      characteristic: [
        [793, "Awareness of process vulnerability", "Demonstrates awareness of process vulnerability."],
        [794, "Crisis Leadership and Resilience", "Demonstrates resilience mindset."],
        [795, "Attention to near misses", "Demonstrates attention to near misses."],
        [796, "Systems thinking", "Demonstrates systems thinking."],
        [797, "Preparedness orientation", "Demonstrates preparedness orientation."],
        [798, "Willingness to learn from failure", "Demonstrates willingness to learn from failure."],
      ],
      behaviour: [
        [799, "Maintenance of framework for operational risk events and", "Maintains a framework for operational risk events and loss data."],
        [800, "Identification of risks in critical processes, people, systems", "Identifies risks in critical processes, people, systems and third parties."],
        [801, "Analytical Thinking and Evidence Use", "Ensures incident analysis identifies root causes and systemic lessons."],
        [802, "Crisis Leadership and Resilience", "Coordinates business continuity and operational resilience testing."],
        [803, "Monitoring of recurring incidents and validates corrective action", "Monitors recurring incidents and validates corrective action."],
        [804, "Assesses the ability to maintain important services during", "Assesses the ability to maintain important services during disruption."],
      ],
    },
    {
      name: 'Regulatory Compliance & Conduct Risk',
      characteristic: [
        [805, "Integrity and Ethical Leadership", "Demonstrates ethical conviction."],
        [806, "Respect for regulatory obligations", "Demonstrates respect for regulatory obligations."],
        [807, "Awareness of conduct consequences", "Demonstrates awareness of conduct consequences."],
        [808, "Independence", "Demonstrates independence."],
        [809, "Diversity, Equity and Inclusion", "Demonstrates fairness orientation."],
        [810, "Brand Management and Reputation", "Demonstrates sensitivity to reputational impacts."],
      ],
      behaviour: [
        [811, "Risk Assessment and Oversight", "Coordinates risk oversight of compliance obligations and material regulatory changes."],
        [812, "Ensuring conduct risks are identified and addressed in", "Ensures conduct risks are identified and addressed in business processes."],
        [813, "Monitoring of regulatory breaches, complaints and remediation commitments", "Monitors regulatory breaches, complaints and remediation commitments."],
        [814, "Fraud Prevention and Speak-Up Culture", "Escalates suspected misconduct or non-compliance through appropriate channels."],
        [815, "Tests whether policies are understood and followed in", "Tests whether policies are understood and followed in practice."],
        [816, "Leadership Effectiveness", "Advises leadership on regulatory and conduct implications of material decisions."],
      ],
    },
    {
      name: 'Risk Culture, Conduct & Accountability',
      characteristic: [
        [817, "Integrity and Ethical Leadership", "Demonstrates integrity."],
        [818, "Constructive Challenge and Scepticism", "Demonstrates constructive challenge."],
        [819, "Diversity, Equity and Inclusion", "Demonstrates fairness."],
        [820, "Personal courage", "Demonstrates personal courage."],
        [821, "Continuous Learning and Improvement", "Demonstrates commitment to learning."],
        [822, "Fraud Prevention and Speak-Up Culture", "Demonstrates respect for speak-up culture."],
      ],
      behaviour: [
        [823, "Promotes clear ownership of risks within business management", "Promotes clear ownership of risks within business management."],
        [824, "Encouragement of reporting of incidents, near misses and", "Encourages timely reporting of incidents, near misses and emerging concerns."],
        [825, "Constructive Challenge of excessive risk-taking and discourages concealment", "Challenges excessive risk-taking and discourages concealment of bad news."],
        [826, "Integrates risk responsibilities into relevant objectives and decision", "Integrates risk responsibilities into relevant objectives and decision processes."],
        [827, "Application of lessons from failures to improve behaviour", "Uses lessons from failures to improve behaviour and control design."],
        [828, "Analytical Thinking and Evidence Use", "Assesses risk culture through evidence, feedback and observed management practices."],
      ],
    },
    {
      name: 'Risk Framework Governance & Continuous Improvement',
      characteristic: [
        [829, "Commitment to disciplined governance", "Demonstrates commitment to disciplined governance."],
        [830, "Adaptability", "Demonstrates adaptability."],
        [831, "Pragmatism", "Demonstrates pragmatism."],
        [832, "Focus on effectiveness rather than paperwork", "Demonstrates focus on effectiveness rather than paperwork."],
        [833, "Openness to independent review", "Demonstrates openness to independent review."],
        [834, "Continuous Learning and Improvement", "Demonstrates continuous-learning orientation."],
      ],
      behaviour: [
        [835, "Maintenance of risk policies, methodologies, roles and reporting", "Maintains clear risk policies, methodologies, roles and reporting lines."],
        [836, "Change Management", "Reviews the risk framework against organizational changes and external requirements."],
        [837, "Coordination of assurance activities to identify gaps and", "Coordinates assurance activities to identify gaps and avoid unnecessary duplication."],
        [838, "Tracking of findings from audits, incidents and reviews", "Tracks findings from audits, incidents and reviews through to closure."],
        [839, "Evaluation of whether risk processes improve decisions and", "Evaluates whether risk processes improve decisions and reduce material exposure."],
        [840, "Updating of tools, training and governance based on", "Updates tools, training and governance based on lessons and emerging practices."],
      ],
    },
    {
      name: 'Risk Identification & Assessment',
      characteristic: [
        [841, "Crisis Leadership and Resilience", "Demonstrates anticipation of emerging threats."],
        [842, "Analytical Thinking and Evidence Use", "Demonstrates analytical rigor."],
        [843, "Systems thinking", "Demonstrates systems thinking."],
        [844, "Constructive Challenge and Scepticism", "Demonstrates professional skepticism."],
        [845, "Awareness of uncertainty", "Demonstrates awareness of uncertainty."],
        [846, "Decision-Making and Judgement", "Demonstrates balanced qualitative and quantitative judgment."],
      ],
      behaviour: [
        [847, "Risk Assessment and Oversight", "Maintains a structured process to identify and assess material risks."],
        [848, "Application of consistent methods to evaluate likelihood, impact", "Uses consistent methods to evaluate likelihood, impact and velocity."],
        [849, "Consideration of interdependencies, concentration and correlated exposures", "Considers interdependencies, concentration and correlated exposures."],
        [850, "Risk Assessment and Oversight", "Validates risk assessments with relevant subject-matter experts and data."],
        [851, "Planning and Prioritisation", "Prioritizes risks by materiality and potential enterprise impact."],
        [852, "Change Management", "Updates assessments when incidents, indicators or external conditions change."],
      ],
    },
    {
      name: 'Risk Measurement, Modeling & Stress Testing',
      characteristic: [
        [853, "Analytical Thinking and Evidence Use", "Demonstrates quantitative literacy."],
        [854, "Awareness of model limitations", "Demonstrates awareness of model limitations."],
        [855, "Scenario-thinking capability", "Demonstrates scenario-thinking capability."],
        [856, "Independence and Objectivity", "Demonstrates intellectual objectivity."],
        [857, "Caution around false precision", "Demonstrates caution around false precision."],
        [858, "Appreciation of tail risk", "Demonstrates appreciation of tail risk."],
      ],
      behaviour: [
        [859, "Application of metrics and models to quantify material", "Uses appropriate metrics and models to quantify material exposures."],
        [860, "Data Governance and Analytics", "Tests assumptions, data quality and limitations in risk models."],
        [861, "Conducts stress tests and scenarios covering severe but", "Conducts stress tests and scenarios covering severe but plausible conditions."],
        [862, "Decision-Making and Judgement", "Compares model outputs with judgment, external evidence and actual outcomes."],
        [863, "Change Management", "Documents model changes, validation and approval decisions."],
        [864, "Financial Planning and Forecasting", "Uses results to inform limits, capital, liquidity or resilience planning as relevant."],
      ],
    },
    {
      name: 'Risk Mitigation & Control Effectiveness',
      characteristic: [
        [865, "Practical problem-solving", "Demonstrates practical problem-solving."],
        [866, "Control awareness", "Demonstrates control awareness."],
        [867, "Decision-Making and Judgement", "Demonstrates proportionate risk judgment."],
        [868, "Persistence in remediation", "Demonstrates persistence in remediation."],
        [869, "Accountability orientation", "Demonstrates accountability orientation."],
        [870, "Balance between protection and business enablement", "Demonstrates balance between protection and business enablement."],
      ],
      behaviour: [
        [871, "Collaborative Working on with risk owners to select", "Works with risk owners to select proportionate mitigation measures."],
        [872, "Assesses whether controls reduce exposure to acceptable levels", "Assesses whether controls reduce exposure to acceptable levels."],
        [873, "Tracking of control deficiencies, remediation deadlines and residual", "Tracks control deficiencies, remediation deadlines and residual risk."],
        [874, "Constructive Challenge of controls that are ineffective, duplicative", "Challenges controls that are ineffective, duplicative or poorly designed."],
        [875, "Analytical Thinking and Evidence Use", "Verifies remediation through testing or independent evidence."],
        [876, "Accepts residual risk only through authorized and documented", "Accepts residual risk only through authorized and documented processes."],
      ],
    },
    {
      name: 'Risk Monitoring, Reporting & Escalation',
      characteristic: [
        [877, "Vigilance", "Demonstrates vigilance."],
        [878, "Stakeholder Communication", "Demonstrates clarity in communication."],
        [879, "Integrity and Ethical Leadership", "Demonstrates commitment to transparency."],
        [880, "Decision-Making and Judgement", "Demonstrates judgment about materiality."],
        [881, "Willingness to escalate", "Demonstrates willingness to escalate."],
        [882, "Independence from undue pressure", "Demonstrates independence from undue pressure."],
      ],
      behaviour: [
        [883, "Execution and Delivery", "Establishes key risk indicators, thresholds and accountable owners."],
        [884, "Provision of , decision-useful risk reporting to executives", "Provides timely, decision-useful risk reporting to executives and the board."],
        [885, "Escalates breaches and emerging exposures according to clear", "Escalates breaches and emerging exposures according to clear triggers."],
        [886, "Explains risk trends, uncertainty and potential consequences plainly", "Explains risk trends, uncertainty and potential consequences plainly."],
        [887, "Tracking of remediation actions and overdue risk responses", "Tracks remediation actions and overdue risk responses."],
        [888, "Internal Control Effectiveness", "Ensures reports accurately represent the organization's exposure and control effectiveness."],
      ],
    },
    {
      name: 'Third-Party, Supply Chain & Outsourcing Risk',
      characteristic: [
        [889, "Awareness of dependency risk", "Demonstrates awareness of dependency risk."],
        [890, "Commercial skepticism", "Demonstrates commercial skepticism."],
        [891, "Crisis Leadership and Resilience", "Demonstrates resilience orientation."],
        [892, "Understanding of external exposure", "Demonstrates understanding of external exposure."],
        [893, "Decision-Making and Judgement", "Demonstrates proportionate due diligence judgment."],
        [894, "Focus on accountability across boundaries", "Demonstrates focus on accountability across boundaries."],
      ],
      behaviour: [
        [895, "Classifies third parties according to criticality and risk", "Classifies third parties according to criticality and risk exposure."],
        [896, "Regulatory Compliance and Governance", "Ensures due diligence covers financial, cyber, operational and compliance risks as relevant."],
        [897, "Monitoring of critical supplier performance, incidents and control", "Monitors critical supplier performance, incidents and control assurance."],
        [898, "Assesses concentration, subcontracting and exit risks", "Assesses concentration, subcontracting and exit risks."],
        [899, "Ensuring contracts specify controls, notification and continuity expectations", "Ensures contracts specify appropriate controls, notification and continuity expectations."],
        [900, "Planning and Prioritisation", "Maintains credible alternatives or exit plans for critical dependencies."],
      ],
    },
  ],
}
